import moment from 'moment'
import { isSet } from '@/plugins/isTypes'

/**
 *  ex: <span>{{ 'aaaa' | test(1234) }}</span>
 */
export default {
  dateFormat: function(value, pattern = 'YYYY-MM-DD HH:mm:ss') {
    if (Number(value) <= 0 || isSet(value) === false) return ''
    return moment(value).format(pattern)
  }
}
